angular.module('App.MyAccount.Profile.SVC', ['jv.Admin.Users.Ajax.Factory'])

.factory('myAccountProfileURLFAC', ['$window', function ($window) {
    var myAccountUrl = $window.jvUrls.admin + '/action/myAccount';
    return {
        alternateApprovers: {
            get: (myAccountUrl + '/vacationsetting/alternateApprovers'),
            post: (myAccountUrl + '/vacationsetting/alternateApprovers')
        },
        outOfoffice: {
            get: (myAccountUrl + '/vacationsetting/isUserOutOfOffice'),
            put: (myAccountUrl + '/vacationsetting/isUserOutOfOffice')
        }
    };
}])

.service('myAccountProfileSvc', ['prepareAjaxCall', 'myAccountProfileURLFAC',
    function (prepareAjaxCall, myAccountProfileURLFAC) {
        this.getAlternateApprovers = function(callback, fail) {
            var options = {
                'ajaxtype': 'myAccountGETAlternateApprovers',
                'url': myAccountProfileURLFAC.alternateApprovers.get
            };
            prepareAjaxCall({}, options, callback, fail);
        };

        this.saveAlternateApprovers = function(data, callback, fail) {
            var options = {
                'ajaxtype': 'myAccountPOSTAlternateApprovers',
                'url': myAccountProfileURLFAC.alternateApprovers.post,
                'requestType': 'POST',
                'headerType': 'json'
            };
            prepareAjaxCall(data, options, callback, fail);
        };

        this.getOutOfOfficeSetting = function(callback, fail) {
            var options = {
                'ajaxtype': 'myAccountGETOutOfOfficeSetting',
                'url': myAccountProfileURLFAC.outOfoffice.get
            };
            prepareAjaxCall({}, options, callback, fail);
        };

        this.saveOutOfOfficeSetting = function(data, callback, fail) {
            var options = {
                'ajaxtype': 'myAccountPOSTOutOfOfficeSettings',
                'url': myAccountProfileURLFAC.outOfoffice.put,
                'requestType': 'PUT',
                'headerType': 'json'
            };
            prepareAjaxCall(data, options, callback, fail);
        };
    }
]);